// Funciones para obtener y gestionar los datos del usuario
import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// Función para obtener los datos del usuario actual desde la base de datos
export const obtenerDatosUsuario = async () => {
  try {
    // Para el sistema de autenticación basado en sesiones, no necesitamos enviar token encabezado
    // El backend verificará si existe una sesión activa
    // Incluimos withCredentials para asegurar que se envíen las cookies de sesión
    const response = await axios.get(`${API_BASE_URL}/obtener_usuario.php`, {
      withCredentials: true
    });

    if (response.data.success && response.data.authenticated) {
      return {
        success: true,
        user: response.data.user
      };
    } else {
      return {
        success: false,
        message: response.data.message || 'Usuario no autenticado'
      };
    }
 } catch (error) {
    console.error('Error al obtener datos del usuario:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Error al obtener datos del usuario'
    };
 }
};

// Función para obtener las estadísticas de un usuario específico
export const obtenerEstadisticasUsuario = async (userId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/obtener_estadisticas_usuario.php?id=${userId}`, {
      withCredentials: true
    });

    return response.data;
  } catch (error) {
    console.error('Error al obtener estadísticas del usuario:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Error al obtener estadísticas del usuario'
    };
  }
};

// Función para actualizar los datos del usuario en la base de datos
export const actualizarDatosUsuario = async (userData) => {
  try {
    // Obtener los datos del usuario actual para determinar permisos
    const currentUserResponse = await obtenerDatosUsuario();
    if (!currentUserResponse.success) {
      throw new Error('No se pudo obtener la información del usuario actual');
    }
    
    const currentUser = currentUserResponse.user;
    let userDataToSend = { ...userData };
    
    // Filtrar los campos según los permisos del usuario actual
    if (currentUser.rol !== 'admin' && currentUser.rol !== 'moderador') {
      // Si el usuario no es admin o moderador, solo permitir campos básicos
      const camposBasicos = ['username', 'foto_perfil'];
      const filteredData = {};
      camposBasicos.forEach(campo => {
        if (userDataToSend[campo] !== undefined) {
          filteredData[campo] = userDataToSend[campo];
        }
      });
      userDataToSend = filteredData;
    }
    
    const response = await axios.post(`${API_BASE_URL}/actualizar_perfil.php`, userDataToSend, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });

    return response.data;
  } catch (error) {
    console.error('Error al actualizar datos del usuario:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Error al actualizar datos del usuario'
    };
  }
};

// Función para obtener premios del usuario
export const obtenerPremiosUsuario = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/obtener_premios_usuario.php`, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener premios del usuario:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Error al obtener premios del usuario'
    };
  }
};

// Función para reclamar premio diario
export const reclamarPremioDiario = async () => {
  try {
    const response = await axios.post(`${API_BASE_URL}/reclamar_premio_diario.php`, {}, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Error al reclamar premio diario:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Error al reclamar premio diario'
    };
  }
};
